document.addEventListener("DOMContentLoaded", function () {
  const collectionList = document.querySelector(".collection-list");
  const listViewBtn = document.getElementById("list-view-btn");
  const gridViewBtn = document.getElementById("grid-view-btn");
  const totalViewBtn = document.getElementById("total-view-btn");
  const sortOptions = document.getElementById("sort-options"); // Ensure this element is defined
  const addToCartButtons = document.querySelectorAll(".add-to-cart");
  const variantImages = document.querySelectorAll(
    ".color-image .variant-image"
  );
  const productImages = document.querySelectorAll(".main-product-image");

  productImages.forEach((image) => {
    const parent = image.closest(".product-image");

    // Ensure the parent container is positioned and styled correctly
    if (parent) {
      parent.style.position = "relative";
      parent.style.overflow = "hidden";
      parent.style.width = "100%";
      parent.style.height = "250px"; // Adjust to your desired height
    }

    // Add hover-based zoom functionality
    parent.addEventListener("mousemove", (e) => {
      const rect = parent.getBoundingClientRect();

      // Calculate the position of the mouse relative to the image container
      const offsetX = Math.min(
        100,
        Math.max(0, ((e.clientX - rect.left) / rect.width) * 100)
      );
      const offsetY = Math.min(
        100,
        Math.max(0, ((e.clientY - rect.top) / rect.height) * 100)
      );

      // Apply zoom transform to the image centered on the cursor
      image.style.transformOrigin = `${offsetX}% ${offsetY}%`;
      image.style.transform = `scale(2.5)`; // Zoom scale
      image.style.transition = "transform 0.1s ease"; // Smooth zoom
    });

    // Reset the zoom when the mouse leaves the container
    parent.addEventListener("mouseleave", () => {
      image.style.transform = "scale(1)";
      image.style.transition = "transform 0.2s ease-out"; // Smooth reset
    });
  });

  variantImages.forEach((variantImage) => {
    // Create a preview image element for each variant
    const previewImage = document.createElement("img");
    previewImage.classList.add("variant-image-preview");
    previewImage.style.position = "absolute";
    previewImage.style.display = "none";
    previewImage.style.zIndex = "1000"; // Ensure it's on top of other elements
    previewImage.style.width = "600px"; // Set preview image size

    // Append the preview image to the body to overlay on everything
    document.body.appendChild(previewImage);

    // Event listeners to handle hover effect for each variant
    variantImage.addEventListener("mouseover", () => {
      // Set the src of the preview image to the same as the variant image
      previewImage.src = variantImage.src;
      previewImage.style.display = "block"; // Show the preview image
    });

    variantImage.addEventListener("mousemove", (e) => {
      // Position the preview slightly offset from the cursor
      previewImage.style.left = `${e.pageX + 20}px`; // 20px to the right of the cursor
      previewImage.style.top = `${e.pageY + 200}px`; // 20px below the cursor
    });

    variantImage.addEventListener("mouseout", () => {
      previewImage.style.display = "none"; // Hide the preview image
    });
  });

  // Update cart item count in the header without a page reload
  function updateCartCount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        const cartCountBubble = document.querySelector(
          ".cart-count-bubble span[aria-hidden='true']"
        );
        if (cartCountBubble) {
          cartCountBubble.innerText = data.item_count;
          cartCountBubble.parentElement.style.display =
            data.item_count > 0 ? "inline-block" : "none";
        }
      })
      .catch((error) => console.error("Error updating cart count:", error));
  }

  // AJAX Add to Cart
  addToCartButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const variantId = this.getAttribute("data-variant-id");
      const quantity = 1; // Default quantity to add

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: variantId, quantity: quantity }),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            console.error("Failed to add item to cart.");
          }
        })
        .then((data) => {
          console.log("Item added to cart:", data);
          updateCartCount(); // Update the cart count in the header
        })
        .catch((error) => console.error("Error adding item to cart:", error));
    });
  });

  // Function to set the active view
  function setActiveView(view) {
    collectionList.className = `collection-list ${view}-view`;
    listViewBtn.classList.toggle("active", view === "list");
    gridViewBtn.classList.toggle("active", view === "grid");
    totalViewBtn.classList.toggle("active", view === "total");
    localStorage.setItem("currentView", view); // Store the current view
  }

  // Set default or saved view on page load
  const savedView = localStorage.getItem("currentView") || "grid";
  setActiveView(savedView);

  // Event listeners for view buttons
  listViewBtn.addEventListener("click", () => setActiveView("list"));
  gridViewBtn.addEventListener("click", () => setActiveView("grid"));
  totalViewBtn.addEventListener("click", () => setActiveView("total"));

  // Sorting functionality
  if (sortOptions) {
    sortOptions.addEventListener("change", function () {
      const sortBy = sortOptions.value;
      if (sortBy === "alphabetical") {
        window.location.href = "?sort_by=title-ascending";
      } else if (sortBy === "newest") {
        window.location.href = "?sort_by=created-descending";
      }
    });
  }

  // Handle image update for variants within the specific product container
  document
    .querySelectorAll(".product-container")
    .forEach(function (productContainer) {
      productContainer
        .querySelectorAll(".variant-image")
        .forEach(function (variantImg) {
          variantImg.addEventListener("click", function () {
            const newImageUrl = this.getAttribute("src");
            updateImage(productContainer, newImageUrl); // Update image within the same product container
          });
        });
    });

  // Function to update the main image within the specific product container
  function updateImage(productContainer, newImageUrl) {
    const mainImage = productContainer.querySelector(".main-product-image");
    if (mainImage) {
      mainImage.src = newImageUrl;
      mainImage.setAttribute("data-action", "zoom"); // Enable zoom on the image
    }
  }

  // Model Image Modal functionality
  const modal = document.getElementById("model-image-modal");
  const modalImg = document.getElementById("model-image-modal-img");
  const closeBtn = document.querySelector(".modal .close");

  // Event listener for closing the modal
  if (closeBtn && modal) {
    closeBtn.addEventListener("click", function () {
      modal.style.display = "none";
    });
  }

  // Event listener for clicking on the "Model Image Available" link
  document.querySelectorAll(".model-image-text a").forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const modelImageUrl = this.getAttribute("data-model-image");
      if (modalImg && modal) {
        modalImg.src = modelImageUrl;
        modal.style.display = "block";
      } else {
        console.error("Model image URL not found.");
      }
    });
  });

  // Add product labels for News and TOP 10 BESTSELLER tags
  document
    .querySelectorAll(".product-container")
    .forEach(function (productContainer) {
      const tags = productContainer.getAttribute("data-tags");

      // Checking for 'News' tag
      if (tags.includes("News")) {
        const label = document.createElement("div");
        label.className = "product-label label-new"; // Add the 'label-new' class for gradient
        label.innerText = "New!";
        label.style.color = "white";
        label.style.position = "absolute";
        label.style.top = "10px";
        label.style.right = "10px";
        label.style.padding = "5px";
        label.style.borderRadius = "3px";
        productContainer.appendChild(label);
      }

      // Checking for 'TOP 10 BEST SELLER' tag (accounting for concatenated tags)
      if (tags.includes("TOP 10 BESTSELLERS")) {
        const label = document.createElement("div");
        label.className = "product-label top-seller-label";
        label.innerText = "TOP 10 BESTSELLER!";
        label.style.backgroundColor = "black";
        label.style.color = "white";
        label.style.position = "absolute";
        label.style.right = "0px";
        label.style.padding = "5px";
        label.style.borderRadius = "0px";

        // Different margin-top for mobile and desktop
        if (window.innerWidth <= 768) {
          label.style.top = "0px";
          label.style.marginTop = "0px";
        } else {
          label.style.top = "0px";
          label.style.marginTop = "85px";
        }

        productContainer.appendChild(label);
      }
    });

  // Adjust the label when window is resized
  window.addEventListener("resize", function () {
    document.querySelectorAll(".top-seller-label").forEach(function (label) {
      if (window.innerWidth <= 768) {
        label.style.top = "0px";
        label.style.marginTop = "0px";
      } else {
        label.style.top = "0px";
        label.style.marginTop = "85px";
      }
    });
  });
});
